var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { grey: "", "lighten-4": "", fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c("MonthYearPicker", {
            attrs: {
              month: _vm.month,
              year: _vm.year,
              mandatory: "",
              cols: "12",
              sm: "6",
              md: "2"
            },
            on: {
              "update:month": function($event) {
                _vm.month = $event
              },
              "update:year": function($event) {
                _vm.year = $event
              }
            }
          }),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "3" } },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.activities,
                  loading: _vm.$apollo.queries.activities.loading,
                  label: _vm.$tc("timesheetActivity.titles.entryChoice"),
                  "item-value": "id",
                  "item-text": "name"
                },
                model: {
                  value: _vm.activityId,
                  callback: function($$v) {
                    _vm.activityId = $$v
                  },
                  expression: "activityId"
                }
              })
            ],
            1
          ),
          _vm.$can("be_timesheet_showDepartmentPicker")
            ? _c(
                "v-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.hideDepartmentPicker,
                      expression: "!hideDepartmentPicker"
                    }
                  ],
                  attrs: { cols: "12", sm: "6", md: "3" }
                },
                [
                  _c("DepartmentPicker", {
                    attrs: {
                      value: _vm.department,
                      "planned-by": !_vm.$can("be_timesheet_viewAll")
                        ? [(_vm.$app.profile && _vm.$app.profile.id) || "-1"]
                        : null,
                      "has-user-work-models": "",
                      clearable: ""
                    },
                    on: {
                      change: function($event) {
                        _vm.department = $event
                      },
                      total: function($event) {
                        _vm.hideDepartmentPicker = !$event
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("LayoutGrid", {
                attrs: {
                  "grid-column-state-key": "be_timesheet_balanceControl",
                  title: _vm.$t("hourOverview.balanceControl.title"),
                  columns: _vm.columns,
                  "row-data": _vm.rows,
                  options: _vm.gridOptions,
                  loading: _vm.$apollo.queries.rows.loading,
                  "no-create": "",
                  "no-show": "",
                  "no-edit": "",
                  "no-delete": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "additionalActions",
                    fn: function() {
                      return [
                        _c(
                          "v-btn",
                          {
                            attrs: { to: { name: "be.timesheet" }, small: "" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("hourOverview.timesheet.title")) +
                                " "
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "800" },
          model: {
            value: _vm.showPayoutsTable,
            callback: function($$v) {
              _vm.showPayoutsTable = $$v
            },
            expression: "showPayoutsTable"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _vm.showPayoutsTable
                    ? _c("PayoutsTable", {
                        ref: "payoutTable",
                        attrs: {
                          "department-filter-visible": _vm.$can(
                            "be_timesheet_showDepartmentPicker"
                          )
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }